import axios from 'axios';

// نسخة axios منفصلة تماماً عن utils/api.js الخاص بالمستخدمين العاديين:
// تستخدم مفتاح localStorage مختلف (dist_token) وتُعيد التوجيه لصفحة دخول
// الموزع عند انتهاء الجلسة بدلاً من صفحة دخول المستخدم العادي.
const API_URL = process.env.REACT_APP_API_URL || '';

const distributorApi = axios.create({
  baseURL: `${API_URL}/api`,
  timeout: 30000,
});

distributorApi.interceptors.request.use(config => {
  if (!navigator.onLine) {
    return Promise.reject({ userMessage: 'تعذر الاتصال — تأكد من اتصالك بالشبكة' });
  }
  const token = localStorage.getItem('dist_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// متغير لمنع محاولات تجديد متعددة في نفس الوقت (نفس نمط utils/api.js تماماً)
let isRefreshing = false;
let pendingQueue = []; // طلبات معلقة تنتظر تجديد التوكن

function processPendingQueue(error, token = null) {
  pendingQueue.forEach(p => error ? p.reject(error) : p.resolve(token));
  pendingQueue = [];
}

distributorApi.interceptors.response.use(
  res => res,
  async err => {
    const url            = err.config?.url || '';
    const isAuthEndpoint = url.includes('/distributor/login') || url.includes('/distributor/refresh');
    const originalReq    = err.config;

    if (!err.response) {
      err.userMessage = 'تعذر الاتصال — تأكد من اتصالك بالواي فاي';
      return Promise.reject(err);
    }

    // ── تجديد تلقائي للـ access token عند انتهاء صلاحيته ──────────────────
    if (err.response?.status === 401 && !isAuthEndpoint && !originalReq._retried) {
      const refreshToken = localStorage.getItem('dist_refreshToken');

      // لا يوجد refresh token → تسجيل خروج فوري
      if (!refreshToken) {
        localStorage.removeItem('dist_token');
        localStorage.removeItem('dist_refreshToken');
        localStorage.removeItem('dist_user');
        window.location.href = '/distributor/login';
        return Promise.reject(err);
      }

      // لو في تجديد جارٍ → أضف الطلب للقائمة المنتظرة
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          pendingQueue.push({
            resolve: (token) => { originalReq.headers.Authorization = `Bearer ${token}`; resolve(distributorApi(originalReq)); },
            reject,
          });
        });
      }

      originalReq._retried = true;
      isRefreshing = true;

      try {
        const { data } = await axios.post(`${API_URL}/api/distributor/refresh`, { refreshToken });
        localStorage.setItem('dist_token', data.token);
        localStorage.setItem('dist_refreshToken', data.refreshToken);
        distributorApi.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
        processPendingQueue(null, data.token);
        originalReq.headers.Authorization = `Bearer ${data.token}`;
        return distributorApi(originalReq); // أعد إرسال الطلب الأصلي بالتوكن الجديد
      } catch (refreshErr) {
        processPendingQueue(refreshErr);
        // نسجّل خروج فقط لو الرفض كان صريحاً من السيرفر (401 = توكن التجديد
        // نفسه غير صالح). أي خطأ آخر (انقطاع شبكة، مهلة، خطأ سيرفر مؤقت 500)
        // لا يعني إن الجلسة انتهت فعلاً — نُبقي الموزع مسجّلاً دخوله ونكتفي
        // بفشل هذا الطلب، يقدر يعيد المحاولة لاحقاً بدون ما يفقد جلسته.
        if (refreshErr.response?.status === 401) {
          localStorage.removeItem('dist_token');
          localStorage.removeItem('dist_refreshToken');
          localStorage.removeItem('dist_user');
          window.location.href = '/distributor/login';
        }
        return Promise.reject(refreshErr);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(err);
  }
);

export default distributorApi;
